import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from '../locales/en/translation.json';
import fiTranslation from '../locales/fi/translation.json';
import svTranslation from '../locales/sv/translation.json';

// Language resources
const resources = {
  en: {
    translation: enTranslation,
  },
  fi: {
    translation: fiTranslation,
  },
  sv: {
    translation: svTranslation,
  },
};

// Supported languages
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'fi', name: 'Finnish', nativeName: 'Suomi' },
  { code: 'sv', name: 'Swedish', nativeName: 'Svenska' },
];

// Initialize i18next
i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Fallback language
    supportedLngs: ['en', 'fi', 'sv'], // Supported languages
    
    // Language detection options
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache user language
      caches: ['localStorage'],
      // localStorage key
      lookupLocalStorage: 'omniapps-language',
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Debugging (disable in production)
    debug: import.meta.env.DEV,

    // React options
    react: {
      useSuspense: false, // Disable suspense for now
    },
  });

export default i18n;
